import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent, HttpResponse } from "@angular/common/http";
import { Observable, tap } from "rxjs";

export const loggingInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const start = Date.now();
  // console.log(`[HTTP] → ${req.method} ${req.urlWithParams}`);

  return next(req).pipe(
    tap({
      next: event => {
        if (event instanceof HttpResponse) {
          const elapsed = Date.now() - start;
          // console.log(`[HTTP] ← ${req.method} ${req.urlWithParams} ${event.status} (${elapsed}ms)`);
        }
      },
      error: err => {
        const elapsed = Date.now() - start;
        console.error(`[HTTP] ✗ ${req.method} ${req.urlWithParams} (${elapsed}ms)`, err);
      },
    })
  );
};
